import { ArchivedWrapper } from "widgets/archivedApiary/ui/styles.ts";
import { Button } from "@atomaro/ui-kit";

export const ArchivedApiary = ({ onRestore }: { onRestore: () => void }) => {
    return (
        <ArchivedWrapper>
            <h3>Пасека находится в архиве</h3>
            <Button
                label={"Вынести из архива"}
                onClick={onRestore}
            />
        </ArchivedWrapper>
    );
};
